export const CONSTANTS = {
    BLANK_LINK: "#!",
    FM_AUTH_KEY: "FM_key",
    FM_TOKEN_KEY: "FM_token",
    //FM_SERVER: process.env.REACT_APP_GRAPHQL_URL || "http://localhost:4000/",
    FM_SERVER: process.env.REACT_APP_GRAPHQL_URL || "https://fsl-parea-backend.labs.iguanait.com",
    API_KEY: process.env.REACT_APP_FM_API_KEY || "aWd1YW5pdDpTZWx2YTEyMw==",
};

